import React, { useState } from "react";
import "./FAQ.css";
import { useTranslation } from "react-i18next";

const FAQItem = ({ question, answer }) => {
	const [isOpen, setIsOpen] = useState(false);

	const toggleOpen = () => {
		setIsOpen(!isOpen);
	};

	return (
		<div className="faq-item">
			<div className="faq-question" onClick={toggleOpen}>
				<h3>{question}</h3>
				<span>{isOpen ? "-" : "+"}</span>
			</div>
			{isOpen && (
				<div className="faq-answer">
					<p>{answer}</p>
				</div>
			)}
		</div>
	);
};

const FAQ = () => {
	const { t } = useTranslation();
	const faqData = [
		{
			question: t("FaqQ1"),
			answer: t("FaqA1"),
		},
		{
			question: t("FaqQ2"),
			answer: t("FaqA2"),
		},
		{
			question: t("FaqQ3"),
			answer: t("FaqA3"),
		},
		{
			question: t("FaqQ4"),
			answer: t("FaqA4"),
		},
		{
			question: t("FaqQ5"),
			answer: t("FaqA5"),
		},
		{
			question: t("FaqQ6"),
			answer: t("FaqA6"),
		},
	];

	return (
		<div className="faq">
			<h2>{t("FaqTitle")}</h2>
			<div className="faq-list">
				{faqData.map((item, index) => (
					<FAQItem key={index} question={item.question} answer={item.answer} />
				))}
			</div>
		</div>
	);
};

export default FAQ;
